import React, { ChangeEvent } from 'react';
import Button from 'components/Button';
import useWindowWidth from 'utils/useWindowWidth';
import styles from './EditTextQuestion.module.css';
import { EditTextQuestionTypes } from './EditTextQuestion.types';

const EditTextQuestion = ({
  setEditQuestion,
  editedQuestionText,
  setEditedQuestionText,
  updateQuestionHandler,
}: EditTextQuestionTypes) => {
  const windwoWidth = useWindowWidth();
  const isMobileWidth = windwoWidth < 640;

  const editQuestionTextHandler = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setEditedQuestionText(e.target.value);
  };

  return (
    <>
      <textarea
        value={editedQuestionText}
        onChange={(e) => editQuestionTextHandler(e)}
        className={styles.edit__textarea}
        placeholder="Текст вопроса"
        name=""
        id="answer"
        rows={5}
        required
      />
      <div className={styles.edit__btns_wrapper}>
        <Button
          className={styles.edit__submit_btn}
          text={isMobileWidth ? 'Опубликовать' : 'Изменить и опубликовать'}
          onClick={() => updateQuestionHandler()}
        />
        <Button
          className={styles.edit__cancel_btn}
          text={isMobileWidth ? '' : 'Отмена'}
          onClick={() => setEditQuestion()}
        />
      </div>
    </>
  );
};

export default EditTextQuestion;
